import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import s from './StatusTierPaywall.scss';
const StatusTierPaywall = ({ deviation , className , children  })=>{
    const { t  } = useTranslation();
    const { needsSubscription , isSubscribedButBlocked  } = useSubscriptionTier(deviation);
    // TODO: this is a FE solution and only hides textContent.
    // It could be extracted (if that's something we care about)
    return needsSubscription || isSubscribedButBlocked ? /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: "tier",
        size: 40,
        isLocked: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['subscription-needed-text']
    }, needsSubscription ? t('deviationview.status.unsubscribedMessage') : t('deviationview.status.lockedMessage'))) : /*#__PURE__*/ React.createElement(React.Fragment, null, children);
};
StatusTierPaywall.displayName = 'StatusTierPaywall';
export default StatusTierPaywall;
